<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a class="float-right btn btn-secondary" href="#" @click.prevent="create()">
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Tags</h1>
      <AdminMenu class="pt-2" current="System" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template v-slot:col_type="{ item }">{{ item.type_label }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <TagListMenu :item="item" :id="id" :eventBus="listEvents" />
                </template>
              </ListTable>
            </div>
          </div>
          <div class="row">
            <div class="d-none d-xl-flex col-xl-3"></div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize :value="parseInt(pagination.per_page)" @input="setPerPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import TagListMenu from "./partials/ListMenu";
import EditTagModal from "./partials/Edit";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    AdminMenu,
    TagListMenu,
    EditTagModal
  },
  props: {
    types: { type: Array, default: () => [] }
  },
  methods: {
    routeParam(item) {
      return { tag: item.id };
    },
    create() {
      this.$modal(EditTagModal, {
        tag: {
          id: null,
          name: "",
          type: ""
        },
        types: this.types
      })
        .then(tag => {
          this.store(tag);
        })
        .catch(() => {});
    },
    store(item) {
      this.axios
        .post(this.route("admin.tags.store"), {
          name: item.name,
          type: item.type
        })
        .then(() => {
          this.showAlert(
            "success",
            `A new tag has been added: "${item.name}"`,
            true
          );
          this.refresh();
          $("html,body").animate({ scrollTop: "0px" });
        });
    },
    edit(item) {
      this.$modal(EditTagModal, { tag: item, types: this.types })
        .then(tag => {
          this.update(tag);
        })
        .catch(() => {});
    },
    update(item) {
      this.axios
        .put(this.route("admin.tags.update", this.routeParam(item)), {
          name: item.name,
          type: item.type
        })
        .then(() => {
          this.showAlert(
            "success",
            `"${item.name}" tag successfully updated`,
            true
          );
          this.refresh();
          $("html,body").animate({ scrollTop: "0px" });
        });
    },
    destroy(item) {
      if (
        confirm(
          `Are you sure you would like to remove the tag: "${item.name}"?`
        )
      ) {
        this.axios
          .delete(this.route("admin.tags.destroy", this.routeParam(item)))
          .then(() => {
            this.showAlert("success", `"${item.name}" has been removed`, true);
            this.refresh();
            $("html,body").animate({ scrollTop: "0px" });
          });
      }
    },
    handleMenuAction(action, item) {
      if (action === "edit") {
        this.edit(item);
      } else if (action === "remove") {
        this.destroy(item);
      }
    }
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
  }
};
</script>
